import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

// The one place the timezone plugins are registered. Import dayjs from here
// wherever `.tz()` is used, instead of repeating the two `extend` calls per
// file (PRTL-951 review; navigator has the same module).
dayjs.extend(utc);
dayjs.extend(timezone);

export type { Dayjs } from "dayjs";
export default dayjs;
